/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/base-navigation-menu.fragment';
import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';

export const NavigationMenuFragment = gql`
  ${BaseMenuItemFragment}
  ${BaseNavigationMenuFragment}

  fragment NavigationMenuFragment on NavigationMenu {
    ...BaseNavigationMenuFragment

    menuItemsCollection {
      items {
        __typename
        ... on MenuItem {
          ...BaseMenuItemFragment
        }
      }
    }
  }
`;
